import React from 'react';
import { Navigate } from 'react-router-dom';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import useAppInfo from '../../../hooks/appInfo.hook';
import DashboardLayout from '../../../layouts/Dashboard';
import { PLATFORMS } from '../../../utils/constants';
import NuvemshopAppOnlyCoupons from './NuvemshopAppOnlyCoupons';

export default function Coupons() {
    const { appInfo } = useAppInfo();

    // Each platform handles app only coupons its own way, so each one has its own screen
    if (appInfo.platformId !== PLATFORMS.NUVEMSHOP) {
        return <Navigate to="/" />
    }

    return (
        <DashboardLayout
            Icon={LocalOfferOutlinedIcon}
            title="Cupons"
            subtitle="Escolha quais cupons da sua loja só poderão ser usados no aplicativo"
        >
            <NuvemshopAppOnlyCoupons />
        </DashboardLayout>
    )
}
